import { Component, Input } from '@angular/core';
import { Step } from '../../interfaces/step.interface';

@Component({
    selector: 'portal-steps-indicator',
    templateUrl: './steps-indicator.component.html',
    standalone: false
})
export class StepsIndicatorComponent {
  @Input() steps: Step[];
  @Input() showCompletionMark = false;
}
